// extracted by mini-css-extract-plugin
var _1 = "RentalPortalListingsPortalsCell-moduleRentalPortalListingsPortalsCell__A5Dec TableCellBase-moduleTableCellBase__GDcv6 TableCell-moduleTableCell__hIV2f";
var _2 = "RentalPortalListingsPortalsCell-modulelogo__Tuqen";
export { _1 as "RentalPortalListingsPortalsCell", _2 as "logo" }
